import {
  language_item,
  logout_item,
  profile_item,
  support_item,
} from '../../../../../components/layout/ProfileDropdown';

export default {
  items: {
    [profile_item]: 'Perfil',
    [language_item]: 'Cambiar idioma',
    [support_item]: 'Soporte',
    [logout_item]: 'Cerrar sesión',
  },
};
